<template>
  <PostSigning
    v-bind="messaging"
    :loading="loading"
  />
</template>

<script setup>
// @ts-check
import { computed } from 'vue'
import i18n from '@/locales'

import { useWidgetVerify } from '@/composables/useWidgetVerify'

import PostSigning from '@/components/screens/PostSigningScreen.vue'

const { success, loading } = useWidgetVerify()

const messaging = computed(() => {
  if (loading.value) {
    return {
      heading: '',
      message: ''
    }
  }

  if (success.value) {
    return {
      heading: i18n.t('widgetSigned.verified'),
      messageIntro: i18n.t('widgetSigned.verifiedMessageIntro'),
      message: i18n.t('widgetSigned.verifiedMessage'),
      type: 'success'
    }
  }

  return {
    heading: i18n.t('widgetSigned.alreadyVerified'),
    messageIntro: i18n.t('widgetSigned.alreadyVerifiedMessageIntro'),
    message: i18n.t('widgetSigned.alreadyVerifiedMessage'),
    type: 'warning'
  }
})
</script>
